import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const colWidths = ['sm', 'md', 'lg'];
const getColumnSizeClass = (isXs, colWidth, colSize) => {
    if (colSize === true || colSize === '') {
        return isXs ? 'col' : `col-${colWidth}`;
    }
    else if (colSize === 'auto') {
        return isXs ? 'col-auto' : `col-${colWidth}-auto`;
    }
    return isXs ? `col-${colSize}` : `col-${colWidth}-${colSize}`;
};
const Col = React.forwardRef((_a, ref) => {
    var { className, as: Component = 'div' } = _a, attributes = __rest(_a, ["className", "as"]);
    const colClasses = [];
    colWidths.forEach((colWidth, i) => {
        const columnProp = attributes[colWidth];
        delete attributes[colWidth];
        if (!columnProp && columnProp !== '') {
            return;
        }
        const isXs = !i;
        const colClass = getColumnSizeClass(isXs, colWidth, columnProp);
        colClasses.push(colClass);
    });
    if (!colClasses.length) {
        colClasses.push('col');
    }
    const classes = clsx('col', className, colClasses);
    return React.createElement(Component, Object.assign({}, attributes, { ref: ref, className: classes }));
});
Col.displayName = 'Col';
export { Col };
//# sourceMappingURL=Col.js.map